import { ChoiceGroup, IChoiceGroupOption } from "@fluentui/react";
import React from "react";

import { TimeZone } from "./DateRenderProvider";
import { useDateRender } from "./useDateRender";

export const TimeZonePicker = (): JSX.Element => {
    const { timeZone, setTimeZone } = useDateRender();

    const options = Object.values(TimeZone).map((format) => ({
        key: format,
        text: format
    }));

    const onChange = (_?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption) => {
        if (option) {
            setTimeZone(option.key as TimeZone);
        }
    };

    return (
        <ChoiceGroup
            styles={{ flexContainer: { display: "flex", justifyContent: "space-between", width: "50%" } }}
            label="Time zone:"
            selectedKey={timeZone}
            options={options}
            onChange={onChange}
        />
    );
};
